import Layout from "layout/Layout";
import DateRangeSelector from "pages/dashboard-overview/components/DateRangeSelector";
import useHttp from "hooks/useHttp";
import useAnalyticsFilters from "hooks/useAnalyticsFilters";
import UnifiedKpiCards from "../components/UnifiedKpiCards";
import AttributionTopKpiCards from "pages/analytics/traffic-attribution/components/AttributionTopKpiCards";
import FunnelVisualization from "../components/FunnelVisualization";

export default function OverviewDashboard() {
  const api = useHttp();
  const { filters, dateRange, setDateRange, customRange, setCustomRange } =
    useAnalyticsFilters("thisMonth");

  return (
    <Layout>
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Overview</h1>
        <p className="text-sm text-gray-500 mt-1">Executive summary</p>
      </div>

      <div className="mb-6 flex flex-col gap-4 sm:flex-row sm:justify-between">
        <DateRangeSelector
          selected={dateRange}
          onChange={setDateRange}
          customRange={customRange}
          onCustomRangeChange={setCustomRange}
        />
      </div>

      <UnifiedKpiCards api={api} filters={filters} variant="overview" />

      <div className="mb-2">
        <h2 className="text-lg font-semibold text-gray-900">Top Attribution Summary</h2>
      </div>
      <AttributionTopKpiCards api={api} filters={filters} />

      <div className="mb-6">
        <h2 className="text-lg font-semibold text-gray-900 mb-4">Funnel Snapshot</h2>
        <FunnelVisualization api={api} filters={filters} embedded funnelId="main_offer" />
      </div>
    </Layout>
  );
}
